import React from "react";
import { Box, Typography, Grid, Container, useTheme } from "@mui/material";

const steps = [
    {
        title: "Mission",
        subtitle: "Smarter saving. Better earning. Future-ready",
        image: "https://ik.imagekit.io/arthgyan/Arthgyan_Web/mission?updatedAt=1756998051532",
    },
    {
        title: "Vision",
        subtitle: "Your family’s money. One smart app",
        image: "https://ik.imagekit.io/arthgyan/Arthgyan_Web/vision?updatedAt=1756998051643",
    },
    {
        title: "Value",
        subtitle: "Grow your wealth smartly",
        image: "https://ik.imagekit.io/arthgyan/Arthgyan_Web/value?updatedAt=1756998051635",
    },
];



const MissionCard = ({ title, subtitle, image }) => {
    const theme = useTheme();

    const accent = "#00a8a8";

    return (

        <Box
            sx={{
                p: { xs: 4, md: 5 },
                borderRadius: "18px",
                width: "100%",
                minHeight: "260px",
                background: "#ffffff",
                border: `2px solid ${accent}`,
                transition: "all 0.3s ease",
                position: "relative",
                cursor: "pointer",
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                boxShadow: "0 4px 12px rgba(0,0,0,0.06)",

                "&:hover": {
                    transform: "translateY(-6px)",
                    borderLeftWidth: "4px",
                    borderRightWidth: "4px",
                    boxShadow: "0 15px 30px rgba(0,0,0,0.12)",
                },

                // bottom strip
                "&::after": {
                    content: '""',
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    width: "100%",
                    height: "0px",
                    background: accent,
                    borderBottomLeftRadius: "16px",
                    borderBottomRightRadius: "16px",
                    transition: "height 0.3s ease",
                },

                "&:hover::after": {
                    height: "12px",
                },
            }}
        >
            <Box
                component="img"
                src={image}
                alt={title}
                sx={{
                    width: 55,
                    height: 55,
                    mb: 2,
                    alignSelf: "center",
                }}
            />

            <Typography
                sx={{
                    fontWeight: 700,
                    fontSize: 18,
                    mb: 1.5,
                    // color: "#111",
                    color: theme.palette.text.primary,

                }}
            >
                {title}
            </Typography>

            <Typography
                sx={{
                    fontSize: 14,
                    color: "#444",
                    lineHeight: 1.6,
                }}
            >
                {subtitle}
            </Typography>
        </Box>
    );
};


const Mission = () => {
    const theme = useTheme();
    return (
        <Box
            sx={{
                py: { xs: 4, md: 2 },
                px: { xs: 2, md: 0 },
            }}
        >



            <Typography
                sx={{
                    fontSize: { xs: "20px", sm: "28px", md: "40px" },
                    fontWeight: 600,
                    textAlign: "center",
                    lineHeight: 1.1,
                    mb: 3,
                    animation: "fadeUp 0.9s ease-out both",
                    color: theme.palette.text.primary,
                    position: "relative",
                    display: "inline-block",
                    width: "100%",
                }}
            >
                Our{" "}
                <Box
                    component="span"
                    sx={{
                        fontWeight: 900,
                        background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.text.primary})`,
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        position: "relative",
                        display: "inline-block",
                        "&::after": {
                            content: '""',
                            position: "absolute",
                            bottom: "-4px",
                            left: 0,
                            width: "100%",
                            height: "2px",
                            background: `linear-gradient(90deg, ${theme.palette.primary.main} 0%, transparent 100%)`,
                        }
                    }}
                >
                    mission
                </Box>{" "}
            </Typography>

            <Container maxWidth="lg">
                <Grid container spacing={4} justifyContent="center">
                    {steps.map((step, index) => (
                        <Grid item xs={12} sm={6} md={4} key={index}>
                            <MissionCard {...step} />
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Box>
    );
};

export default Mission;
